module.exports = __webpack_public_path__ + "img/icon_search.50319d2a.svg";